module.exports = __webpack_public_path__ + "media/images/vp/samples/03-ea22368f78f99d6dd579ee8486348f49.jpg";